var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0289 17.5654L16.158 2.58883C15.4416 1.22569 14.0399 0.378906 12.5 0.378906C10.96 0.378906 9.55843 1.22569 8.84196 2.58883L0.971172 17.5654C0.302063 18.8386 0.348465 20.394 1.09211 21.6243C1.83559 22.8553 3.19096 23.6201 4.62919 23.6201H20.3709C21.8089 23.6201 23.1643 22.8554 23.9078 21.6247C24.6515 20.394 24.6979 18.8386 24.0289 17.5654ZM21.8499 20.3813C21.5389 20.8962 20.9721 21.2159 20.3708 21.2159H4.62911C4.02764 21.2159 3.46095 20.8962 3.14992 20.3811C2.83897 19.8666 2.81966 19.2163 3.09943 18.6839L10.9703 3.70722C11.2698 3.13725 11.856 2.7831 12.5 2.7831C13.1439 2.7831 13.7302 3.13717 14.0297 3.70722L21.9005 18.6839C22.1803 19.2163 22.161 19.8666 21.8499 20.3813Z",
    fill: "#17B67C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0433 16.1413H12.9563L13.8471 6.99414H11.1523L12.0433 16.1413Z",
    fill: "#17B67C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 16.9922C11.78 16.9922 11.1973 17.575 11.1973 18.2947C11.1973 19.0136 11.78 19.5971 12.4997 19.5971C13.2193 19.5971 13.8021 19.0136 13.8021 18.2947C13.8021 17.5751 13.2193 16.9922 12.4997 16.9922Z",
    fill: "#17B67C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarn);
export default __webpack_public_path__ + "static/media/warn.0997e53e2029101e0e8ba620e0b7212e.svg";
export { ForwardRef as ReactComponent };